import { createMemo, createSignal, For, Show } from 'solid-js';
import { InputFieldAttributes } from '../mautic-form-types';
import { formatLabel } from '../utils';
import { getEncodedColor } from '../classes';
import clsx from 'clsx';

export const Select = ({ fieldData }: { fieldData: InputFieldAttributes }) => {
    const {
        alias,
        errors,
        id,
        inputClasses,
        isRequired,
        label,
        properties,
        handleChange,
        value,
        variant,
        revalidate,
        errorInputClasses,
        errorLabelClasses,
        errorId,
    } = fieldData;
    const error = () => Boolean(errors[alias]);
    const [hasValue, setHasValue] = createSignal(!!value);
    const options = properties?.list?.list ?? null;
    const stringID = String(id);

    const placeholder = properties?.placeholder ? properties.placeholder + (isRequired ? ' *' : '') : label + (isRequired ? ' *' : '');

    const svgIcon = createMemo(
        () =>
            `data:image/svg+xml,%3Csvg width="18" height="11" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath opacity="${
                hasValue() ? '1' : '0.7'
            }" d="M17 1L9.3333 9L1 0.999999" stroke="${getEncodedColor(variant)}" stroke-width="2"/%3E%3C/svg%3E%0A`,
    );

    return (
        <Show when={options && options.length > 0}>
            <>
                <label class="sr-only" for={stringID}>
                    {formatLabel(label, isRequired)}
                </label>
                <select
                    {...(error() && { 'aria-invalid': true, 'aria-describedby': errorId })}
                    class={clsx(inputClasses, 'appearance-none')}
                    classList={{
                        [errorInputClasses || '']: error(),
                    }}
                    id={stringID}
                    onChange={(e) => {
                        handleChange(alias, e.target.value);
                        setHasValue(e.target.value !== '');
                        revalidate(alias, e.target.value);
                    }}
                    style={{
                        'background-image': `url('${svgIcon()}')`,
                        'background-repeat': 'no-repeat',
                        'background-position': 'right 1.125rem top 50%',
                        'background-size': '0.75rem auto',
                    }}
                    value={typeof value === 'boolean' ? String(value) : value}
                >
                    <option disabled value="">
                        {placeholder}
                    </option>
                    <For each={options}>{(item) => <option value={item.value}>{item.label}</option>}</For>
                </select>
            </>
        </Show>
    );
};
